/** Most lines on one claim. */
export const EXPENSE_MAX_LINES = 50;
